export default __webpack_public_path__ + "images/HR.87d57ed.png";